import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import MagicButton from 'components/MagicButton';

interface ImportErrorProps {
  title?: string;
  message?: string;
  details?: string;
  onRetry?: () => void;
  onBack?: () => void;
}

const ImportError = ({
  title = 'Import Failed',
  message = 'Something went wrong while importing your cards.',
  details,
  onRetry,
  onBack,
}: ImportErrorProps) => {
  return (
    <div className="import-error">
      <div className="import-error-content">
        <FontAwesomeIcon icon={faExclamationCircle} className="import-error-icon" />
        <h2>{title}</h2>
        <p className="import-error-message">{message}</p>
        {details && <p className="import-error-details">{details}</p>}
      </div>

      <div className="import-error-actions">
        {onBack && <MagicButton label="Go Back" color="grey" onPress={onBack} />}
        {onRetry && <MagicButton label="Try Again" color="purple" onPress={onRetry} />}
      </div>
    </div>
  );
};

export default ImportError;
